import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';

import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerSite } from 'src/app/assabil-kernel/models/entities/control-tables/partner-site-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';


@Component({
  selector: 'partner-site-list',
  templateUrl: './partner-site-list.component.html',
  styleUrls: ['./partner-site-list.component.scss']
})

export class PartnerSiteListComponent extends BasePage2<PartnerSite> {
  
  @Input() partnerCodeInput : string;

  partnerCodeFilter       : string
  partnerSites            : PartnerSite[] = [];

  showInMap               : boolean = false;



  
  constructor(
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected router            : Router,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected location          : Location) {
    
       super(toastr, router, baseService, leanUtilsService, location);

       this.entityName = 'partnerSite';
  }

 
  listFields = [
    { prop: 'partnerCode', name: 'Code Partenaire', },
    { prop: 'partnerSiteCode', name: 'Code Site', },
    { prop: 'name', name: 'Name' },
    { prop: 'name', name: 'Name' },

    
    { prop: 'branchCode', name: 'Agence' },
    { prop: 'distanceToBranch', name: 'Distance' },
    { prop: 'timeToBranch', name: 'Temps' },
  ]
  formFields = this.listFields;

  ngOnInit() {
    super.ngOnInit();
    if (this.partnerCodeInput != null) {
        this.partnerCodeFilter = this.partnerCodeInput;
        this.loadData();
    }
  }

  
  getRows(): PartnerSite[] {
    return this.partnerSites;
  }

  initEntityContainer() {
    this.entityContainer = new EntityContainer(PartnerSite);
  }

  saveRow(row: PartnerSite): Promise<PartnerSite> {
    return this.masterDataService.partnerSiteSave(row);
  }
  
  
  loadData() {
    this.masterDataService.partnerSitesGet(this.partnerCodeFilter).then(result => {
      this.partnerSites = result;
      this.buildPoints();
    }).catch(error => {
      this.showError(error);
    })
  }

 
  map(show : boolean){
    if (show){
   //   this.buildPoints();
    }
    this.showInMap = show;
  }

  points : marker[] = [];
  buildPoints(){
  //  this.pointEs : Marker[this.branchs.length];
    let i : number = 0;
    this.partnerSites.forEach(partner => {

      let point : marker = {     
        lat: partner.latitude,
        lng: partner.longitude,
        label: partner.name,
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
      };
    
      this.points.push(point);
    })
  }

}
